/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// DashboardPage.js
import { useEffect, useContext, useState, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { AuthContext } from "../context/AuthContext";
import styled from "styled-components";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../config";

export const DashboardPage = () => {
  const { logout, token } = useContext(AuthContext);
  const { userEmail } = useContext(AuthContext);
  const { userBackupType } = useContext(AuthContext);
  const { permissionLevel } = useContext(AuthContext);
  const [espaco, setEspaco] = useState({ used: 0, total: 10 });
  const [pieSelectedStatus, setPieSelectedStatus] = useState(null);

  const [overdue, setOverdue] = useState([]); // lista de atrasados (.bcir)
  const [loadingOverdue, setLoadingOverdue] = useState(true);

  const fetchOverdue = async () => {
    if (Number(permissionLevel) !== 1) return;

    setLoadingOverdue(true);

    try {
      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_overdue_backups.php`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const data = await res.json();

      if (data?.sucesso) {
        setOverdue(data.atrasados || []);
      } else {
        setOverdue([]);
      }
    } catch (e) {
      console.error("Erro ao buscar atrasados:", e);
      setOverdue([]);
    } finally {
      setLoadingOverdue(false);
    }
  };

  const [horariosBackup, setHorariosBackup] = useState([]);
  const [diasSelecionados, setDiasSelecionados] = useState([]);
  const [backupConfigs, setBackupConfigs] = useState([]);

  const [backupsPendentes, setBackupsPendentes] = useState([]);

  // 👇 ESTADOS SEPARADOS
  const [filterSis, setFilterSis] = useState("day");
  const [dateSis, setDateSis] = useState("");

  const [filterArq, setFilterArq] = useState("day");
  const [dateArq, setDateArq] = useState("");

  const [backupsSucessoSistema, setBackupsSucessoSistema] = useState([]);
  const [backupsSucessoArquivos, setBackupsSucessoArquivos] = useState([]);

  // Pie chart (admin): agrega contagens por STATUS vindos de HORARIOS_BACKUP
  const pieData = useMemo(() => {
    const counts = horariosBackup.reduce((acc, item) => {
      const s = String(item.STATUS || "").toLowerCase();
      acc[s] = (acc[s] || 0) + 1;
      return acc;
    }, {});

    const keys = [
      "sucesso",
      "erro",
      "erro_atraso",
      "pendente",
      "enviando",
      "preparando",
    ];
    const labels = [
      "Sucesso",
      "Erro",
      "Erro (atraso)",
      "Pendente",
      "Enviando",
      "Preparando",
    ];
    const series = keys.map((k) => counts[k] || 0);
    const total = series.reduce((a, b) => a + b, 0);

    const options = {
      chart: {
        type: "pie",
        background: "transparent",
        events: {
          dataPointSelection: (event, ctx, config) => {
            const idx = config?.dataPointIndex ?? -1;
            if (idx >= 0) setPieSelectedStatus(keys[idx]);
          },
        },
      },
      labels,
      theme: { mode: "dark" },
      legend: { position: "right" },
      colors: [
        "#2ecc71",
        "#e74c3c",
        "#962f24ff",
        "#3498db",
        "#f1c40f",
        "#666666",
      ],
      dataLabels: {
        enabled: true,
        formatter: (percent) => `${percent.toFixed(1)}%`,
      },
      tooltip: {
        /* ... do jeito que já está ... */
      },
      responsive: [
        {
          breakpoint: 1200, // antes era 768
          options: {
            legend: { position: "bottom" },
          },
        },
      ],
    };

    return { series, options, total, keys, labels };
  }, [horariosBackup]);

  const DIA_PT = {
    sunday: "Domingo",
    monday: "Segunda-feira",
    tuesday: "Terça-feira",
    wednesday: "Quarta-feira",
    thursday: "Quinta-feira",
    friday: "Sexta-feira",
    saturday: "Sábado",
  };
  const diaLabel = (slug) => DIA_PT[slug?.toLowerCase()] ?? slug;

  useEffect(() => {
    document.title = "Painel";
  }, []);

  useEffect(() => {
    if (Number(permissionLevel) !== 1) return;
    fetchOverdue();
    // Removido o intervalo para parar o reinício automático
    // const id = setInterval(fetchOverdue, 60_000); // 1 min
    // return () => clearInterval(id);
  }, [token, permissionLevel]);

  const fetchBackupsByDatePendentes = async (range) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_status_by_date?range=${range}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      if (data.sucesso) {
        const pendentes = data.dados.filter((b) =>
          ["erro", "enviando", "preparando"].includes(b.STATUS),
        );
        setBackupsPendentes(pendentes);
      }
    } catch (error) {
      console.error("Erro ao buscar backups pendentes:", error);
    }
  };

  const pad = (n) => String(n).padStart(2, "0");
  const nowHHMM = () => {
    const d = new Date();
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const todaySlug = () =>
    new Intl.DateTimeFormat("en-US", { weekday: "long" })
      .format(new Date())
      .toLowerCase();

  const currentTime = new Date();

  const fetchBackupsByDateSucessoTipo = async (
    rangeOrDate,
    bt,
    setter,
    statusQuery = "status=sucesso",
  ) => {
    try {
      const backupTypeIn =
        Number(bt) === 1 ? "1,3" : Number(bt) === 2 ? "2,3" : "1,2,3";

      const url = `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_status_by_date?range=${rangeOrDate}&backup_type_in=${backupTypeIn}&${statusQuery}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.sucesso) setter(data.dados);
    } catch (error) {
      console.error("Erro ao buscar backups por tipo:", error);
    }
  };

  const fetchEspaco = async () => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_storage_usage_v2`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await res.json();
      if (data.sucesso) {
        setEspaco(data);
      }
    } catch (err) {
      console.error("Erro ao obter uso de espaço:", err);
    }
  };

  const fetchHorariosBackup = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/list_user_by_id_v2.php?ui_grace_min=1&ui_grace_sec=30`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      if (data.sucesso) {
        // ADMIN: list_user_by_id_v2 retorna HORARIOS_BACKUP direto
        if (Number(permissionLevel) === 1) {
          setHorariosBackup(data.HORARIOS_BACKUP || []);
          setBackupConfigs([]);
          setDiasSelecionados([]);
          return;
        }

        // USUÁRIO FINAL: list_user_by_id_v2 retorna dados[]
        const configs = Array.isArray(data.dados) ? data.dados : [];

        setBackupConfigs(configs);

        const horariosTodos = configs.flatMap((config) =>
          Array.isArray(config.HORARIOS_BACKUP) ? config.HORARIOS_BACKUP : [],
        );

        setHorariosBackup(horariosTodos);

        const diasTodos = Array.from(
          new Set(
            configs.flatMap((config) =>
              String(config.WEEK_DAYS || "")
                .split(",")
                .map((d) => d.trim())
                .filter(Boolean),
            ),
          ),
        );

        setDiasSelecionados(diasTodos);
      }
    } catch (error) {
      console.error("Erro ao buscar horários de backup:", error);
    }
  };

  // pendentes + horários + espaço (mantém como está, só tire dependência de filter/selectedDate)
  useEffect(() => {
    fetchBackupsByDatePendentes("last30");
    fetchHorariosBackup();
    fetchEspaco();

    const pend = setInterval(() => fetchBackupsByDatePendentes("last30"), 5000);
    const hor = setInterval(fetchHorariosBackup, 10000);
    const esp = setInterval(fetchEspaco, 5000);

    return () => {
      clearInterval(pend);
      clearInterval(hor);
      clearInterval(esp);
    };
  }, [token, userBackupType]);

  // sistema
  useEffect(() => {
    if (Number(userBackupType) === 2) return; // sem sistema
    const range = dateSis || filterSis;
    fetchBackupsByDateSucessoTipo(range, 1, setBackupsSucessoSistema);
    const id = setInterval(
      () => fetchBackupsByDateSucessoTipo(range, 1, setBackupsSucessoSistema),
      5000,
    );
    return () => clearInterval(id);
  }, [filterSis, dateSis, token, userBackupType]);

  // arquivos
  useEffect(() => {
    if (Number(userBackupType) === 1) return;

    const range = dateArq || filterArq;
    const statusQuery =
      Number(permissionLevel) === 1
        ? "status_in=sucesso,enviando"
        : "status=sucesso";

    fetchBackupsByDateSucessoTipo(
      range,
      2,
      setBackupsSucessoArquivos,
      statusQuery,
    );

    const id = setInterval(() => {
      fetchBackupsByDateSucessoTipo(
        range,
        2,
        setBackupsSucessoArquivos,
        statusQuery,
      );
    }, 5000);

    return () => clearInterval(id);
  }, [filterArq, dateArq, token, userBackupType, permissionLevel]);

  const handleDeleteBackup = async (id) => {
    const confirm = await Swal.fire({
      title: "Confirmar exclusão?",
      text: "Deseja realmente remover da listagem este backup com erro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e74c3c",
      cancelButtonColor: "#555",
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      theme: "dark",
    });

    if (confirm.isConfirmed) {
      try {
        const res = await fetch(
          `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/delete_status.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id }),
          },
        );

        const data = await res.json();
        if (data.sucesso) {
          Swal.fire({
            title: "Removido!",
            text: "Backup excluído com sucesso.",
            icon: "success",
            theme: "dark",
          });
          setBackupsPendentes((prev) =>
            prev.filter((b) => b.ID_BACKUP_STATUS !== id),
          );
        } else {
          Swal.fire("Erro", data.erro || "Não foi possível excluir", "error");
        }
      } catch (err) {
        Swal.fire("Erro", "Ocorreu um erro inesperado", "error");
      }
    }
  };

  return (
    <Wrapper>
      <Main>
        <Content>
          <Card>
            <CardTitle>Usuário logado</CardTitle>
            <CardValue>{userEmail}</CardValue>

            {Number(permissionLevel) === 1 && (
              <>
                <CardTitle>Backups Totais de (.bcir) na Nuvem</CardTitle>
                <CardValue>{espaco.bcirCount ?? 0} arquivos</CardValue>
              </>
            )}
          </Card>
          {Number(permissionLevel) === 1 && (
            <Card>
              <CardTitle>
                Resumo de Status (todos os usuários - data de hoje)
              </CardTitle>
              {pieData.total > 0 ? (
                <ChartWrapper style={{ width: "100%", maxWidth: 380 }}>
                  <ReactApexChart
                    options={pieData.options}
                    series={pieData.series}
                    type="pie"
                    width="100%"
                  />
                </ChartWrapper>
              ) : (
                <CardValue>Nenhum dado ainda</CardValue>
              )}

              {pieSelectedStatus && (
                <div style={{ marginTop: "1rem" }}>
                  <p style={{ color: "#aaa", marginBottom: 8 }}>
                    Itens com status: <strong>{pieSelectedStatus}</strong>
                    <button
                      onClick={() => setPieSelectedStatus(null)}
                      style={{
                        marginLeft: 12,
                        background: "transparent",
                        color: "#ccc",
                        border: "1px solid #333",
                        borderRadius: 6,
                        padding: "2px 8px",
                        cursor: "pointer",
                      }}
                    >
                      limpar
                    </button>
                  </p>

                  <div
                    style={{
                      maxHeight: 260,
                      overflowY: "auto",
                      borderTop: "1px solid #333",
                      paddingTop: 8,
                    }}
                  >
                    {horariosBackup
                      .filter(
                        (h) =>
                          String(h.STATUS).toLowerCase() === pieSelectedStatus,
                      )
                      .map((h, i) => (
                        <div
                          key={`${h.EMAIL || h.USER_ID}-${h.DIA_SEMANA}-${
                            h.HORARIO
                          }-${i}`}
                          style={{
                            padding: "6px 0",
                            borderBottom: "1px dashed #333",
                          }}
                        >
                          <div style={{ fontSize: 14, color: "#ddd" }}>
                            {h.EMAIL || `User #${h.USER_ID}`} —{" "}
                            <strong>{h.HORARIO}</strong> (
                            {diaLabel(h.DIA_SEMANA)})
                          </div>
                        </div>
                      ))}
                    {horariosBackup.filter(
                      (h) =>
                        String(h.STATUS).toLowerCase() === pieSelectedStatus,
                    ).length === 0 && (
                      <div style={{ color: "#888", fontStyle: "italic" }}>
                        Nenhum item.
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Card>
          )}

          {Number(permissionLevel) === 1 && (
            <Card>
              <CardTitle>
                🚨 Clientes há 24h+ sem backup de sistema (.bcir)
              </CardTitle>
              {loadingOverdue ? (
                <CardValue>Carregando...</CardValue>
              ) : overdue.length === 0 ? (
                <CardValue>Sem pendências no momento 🎉</CardValue>
              ) : (
                <div style={{ marginTop: 8 }}>
                  <div style={{ maxHeight: 260, overflowY: "auto" }}>
                    {overdue.map((it) => (
                      <div
                        key={`${it.USER_ID}-${it.key}`}
                        style={{
                          padding: "6px 0",
                          borderBottom: "1px dashed #333",
                          lineHeight: 1.35,
                        }}
                      >
                        <div style={{ fontSize: 14, color: "#ddd" }}>
                          👤{" "}
                          <strong>{it.EMAIL || `User #${it.USER_ID}`}</strong>
                        </div>
                        {it.status === "never_backed_up" ? (
                          <>
                            <div style={{ fontSize: 13, color: "#ffb84d" }}>
                              ⚠️{" "}
                              <strong>
                                {it.mensagem || "Usuário nunca realizou backup"}
                              </strong>
                            </div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                              📦 {it.bucket}
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ fontSize: 13, color: "#bbb" }}>
                              ⏱️{" "}
                              <strong>
                                {it.days_since}d {it.remaining_hours_since}h
                              </strong>{" "}
                              desde o último backup
                            </div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                              🕒 {new Date(it.last_backup_iso).toLocaleString()}
                            </div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                              📦 {it.bucket}
                            </div>
                            <div
                              style={{
                                fontSize: 12,
                                color: "#666",
                                wordBreak: "break-all",
                              }}
                            >
                              📄 {it.key}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Card>
          )}

          {(Number(userBackupType) === 2 || Number(userBackupType) === 3) &&
            Number(permissionLevel) !== 1 && (
              <Card>
                <CardTitle>Armazenamento Usado (Arquivos)</CardTitle>
                <CardValue>
                  {espaco.used} GB / {espaco.total} GB
                </CardValue>
              </Card>
            )}

          {(Number(userBackupType) === 1 || Number(userBackupType) === 3) &&
            Number(permissionLevel) !== 1 && (
              <Card>
                <CardTitle>Backups do Sistema (.bcir) na Nuvem</CardTitle>

                {Array.isArray(espaco.bcirFolders) &&
                espaco.bcirFolders.length > 0 ? (
                  <div style={{ marginTop: "0.75rem" }}>
                    {espaco.bcirFolders.map((item) => (
                      <div
                        key={`${item.ID_BACKUP_DATABASE}-${item.BCK_SETTING}`}
                        style={{
                          padding: "6px 0",
                          borderBottom: "1px dashed #333",
                        }}
                      >
                        <div style={{ fontSize: 13, color: "#ccc" }}>
                          <strong>{item.BACKUP_FOLDER}</strong>
                        </div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            marginTop: 2,
                          }}
                        >
                          {item.bcirCount ?? 0} arquivos
                        </div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                          Plano: {item.STORAGE_PLAN}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <CardValue>{espaco.bcirCount ?? 0} arquivos</CardValue>
                )}
              </Card>
            )}
        </Content>

        {Number(userBackupType) !== 2 && Number(permissionLevel) !== 1 && (
          <Card
            style={{
              marginLeft: "2rem",
              marginRight: "2rem",
              padding: "unset",
              marginBottom: "1rem",
              paddingBottom: "15px",
            }}
          >
            <SectionTitle style={{ marginBottom: "15px" }}>
              🗓️ Programação de Horários de Backup do Sistema
            </SectionTitle>

            <div style={{ padding: "0 2rem" }}>
              {/* Legenda */}
              <div
                style={{
                  marginBottom: "15px",
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background: "#2ecc71",
                      borderRadius: 4,
                    }}
                  ></div>
                  <span>Sucesso</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background: "#f39c12",
                      borderRadius: 4,
                    }}
                  ></div>
                  <span>Pendente</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background: "#e74c3c",
                      borderRadius: 4,
                    }}
                  ></div>
                  <span>Erro</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background: "#962f24ff",
                      borderRadius: 4,
                    }}
                  ></div>
                  <span>Erro por atraso</span>
                </div>
              </div>

              {/* Verifica se há dados */}
              {backupConfigs.length === 0 ? (
                <EmptyMessage>
                  Nenhuma programação de backup configurada para este usuário.
                </EmptyMessage>
              ) : (
                backupConfigs.map((config) => {
                  const horarios = Array.isArray(config.HORARIOS_BACKUP)
                    ? config.HORARIOS_BACKUP
                    : [];

                  const dias = String(config.WEEK_DAYS || "")
                    .split(",")
                    .map((d) => d.trim())
                    .filter(Boolean);

                  const horariosUnicos = Array.from(
                    new Set(horarios.map((h) => h.HORARIO)),
                  ).sort();

                  return (
                    <div
                      key={`${config.ID_BACKUP_DATABASE}-${config.BCK_SETTING}`}
                      style={{ marginBottom: "24px" }}
                    >
                      <div
                        style={{
                          marginBottom: "10px",
                          color: "#ccc",
                          fontSize: "0.95rem",
                        }}
                      >
                        <strong>Pasta:</strong> {config.BACKUP_FOLDER}{" "}
                        <span style={{ color: "#888" }}>
                          — Plano: {config.STORAGE_PLAN}
                        </span>
                      </div>

                      <TableViewport>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "center",
                            border: "1px solid rgb(68, 68, 68)",
                            marginBottom: "15px",
                          }}
                        >
                          <thead>
                            <tr>
                              {dias.map((dia) => {
                                const traducao = {
                                  sunday: "Domingo",
                                  monday: "Segunda-feira",
                                  tuesday: "Terça-feira",
                                  wednesday: "Quarta-feira",
                                  thursday: "Quinta-feira",
                                  friday: "Sexta-feira",
                                  saturday: "Sábado",
                                }[dia];

                                return (
                                  <th
                                    key={dia}
                                    style={{
                                      border: "1px solid rgb(68, 68, 68)",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {traducao}
                                  </th>
                                );
                              })}
                            </tr>
                          </thead>

                          <tbody>
                            {horariosUnicos.map((hora) => (
                              <tr key={hora}>
                                {dias.map((dia) => {
                                  const item = horarios.find(
                                    (h) =>
                                      h.DIA_SEMANA === dia &&
                                      h.HORARIO === hora,
                                  );

                                  let status = item?.STATUS ?? null;

                                  if (
                                    status === "erro" &&
                                    dia === todaySlug() &&
                                    hora === nowHHMM()
                                  ) {
                                    status = "pendente";
                                  }

                                  let bg = "#444";
                                  if (status === "sucesso") bg = "#2ecc71";
                                  else if (status === "erro") bg = "#e74c3c";
                                  else if (status === "erro_atraso")
                                    bg = "#962f24ff";
                                  else if (status === "enviando") bg = "#666";
                                  else if (
                                    status === "pendente" ||
                                    status === "preparando"
                                  )
                                    bg = "#f39c12";

                                  return (
                                    <td
                                      key={`${config.BCK_SETTING}-${dia}-${hora}`}
                                      style={{
                                        border: "1px solid rgb(68, 68, 68)",
                                        height: "35px",
                                        background: bg,
                                      }}
                                    >
                                      {item ? hora : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </TableViewport>
                    </div>
                  );
                })
              )}
            </div>
          </Card>
        )}

        {Number(permissionLevel) !== 1 && (
          <Card
            style={{
              marginLeft: "2rem",
              marginRight: "2rem",
              padding: "unset",
              marginBottom: "1rem",
              paddingBottom: "15px",
            }}
          >
            <SectionTitle>
              ⏳ Backups em Andamento ou com Erro (dos últimos 30 dias)
            </SectionTitle>
            <BackupList>
              {backupsPendentes.map((b) => (
                <BackupCard key={b.ID_BACKUP_STATUS} status={b.STATUS}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginTop: "unset" }}>
                      <strong style={{ fontSize: "small" }}>
                        {b.FILE_NAME}
                      </strong>
                    </p>
                    {b.STATUS === "erro" && (
                      <button
                        onClick={() => handleDeleteBackup(b.ID_BACKUP_STATUS)}
                        style={{
                          background: "transparent",
                          color: "#f44336",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          marginLeft: "8px",
                        }}
                        title="Excluir backup com erro"
                      >
                        ✖
                      </button>
                    )}
                  </div>
                  <p>
                    Status:{" "}
                    {b.STATUS === "enviando"
                      ? "🟡"
                      : b.STATUS === "preparando"
                        ? "⚙️"
                        : "❌"}{" "}
                    {b.STATUS}
                  </p>
                  <p>
                    {b.DETAILS === "Enviando arquivo (100%)"
                      ? "Enviando arquivo (100%), concluindo..."
                      : b.DETAILS}
                  </p>
                  {b.STATUS !== "erro" && <ProgressBar progress={b.PROGRESS} />}
                  <small>{new Date(b.CREATED_AT).toLocaleString()}</small>
                </BackupCard>
              ))}
            </BackupList>
            {backupsPendentes.length === 0 && (
              <EmptyMessage>
                Nenhum backup em andamento ou com erro no momento.
              </EmptyMessage>
            )}
          </Card>
        )}

        {Number(userBackupType) !== 2 && (
          <Card
            style={{
              marginLeft: "2rem",
              marginRight: "2rem",
              padding: "unset",
              marginBottom: "1rem",
              paddingBottom: "15px",
            }}
          >
            <>
              {Number(permissionLevel) === 1 && (
                <SectionTitle>
                  📁 Backups com Sucesso do Sistema (últimos 10 - todos os
                  usuários)
                </SectionTitle>
              )}
              {Number(permissionLevel) !== 1 && (
                <SectionTitle>
                  📁 Backups com Sucesso do Sistema (últimos 10)
                </SectionTitle>
              )}
              <FiltroContainer>
                <FiltroBotao
                  ativo={filterSis === "day" && !dateSis}
                  onClick={() => setFilterSis("day")}
                >
                  Hoje
                </FiltroBotao>
                <FiltroBotao
                  ativo={filterSis === "week" && !dateSis}
                  onClick={() => setFilterSis("week")}
                >
                  Semana
                </FiltroBotao>
                <FiltroBotao
                  ativo={filterSis === "all" && !dateSis}
                  onClick={() => setFilterSis("all")}
                >
                  Todos
                </FiltroBotao>

                <DataInput
                  type="date"
                  value={dateSis}
                  onChange={(e) => setDateSis(e.target.value)}
                />
                {dateSis && (
                  <LimparDataBotao onClick={() => setDateSis("")}>
                    ✖
                  </LimparDataBotao>
                )}
              </FiltroContainer>
              <BackupList>
                {backupsSucessoSistema.map((b) => (
                  <BackupCard key={b.ID_BACKUP_STATUS}>
                    <p style={{ marginTop: 0 }}>
                      <strong style={{ fontSize: "small" }}>
                        {b.FILE_NAME}
                      </strong>
                    </p>
                    <p>Status: ✅ {b.STATUS}</p>
                    {Number(permissionLevel) === 1 && (
                      <p>Usuário: 👤 {b.USER_EMAIL}</p>
                    )}
                    <p>{b.DETAILS}</p>
                    <small>{new Date(b.CREATED_AT).toLocaleString()}</small>
                  </BackupCard>
                ))}
              </BackupList>
              {backupsSucessoSistema.length === 0 && (
                <EmptyMessage>
                  Nenhum backup de sistema com sucesso.
                </EmptyMessage>
              )}
            </>
          </Card>
        )}
        {Number(userBackupType) !== 1 && (
          <Card
            style={{
              marginLeft: "2rem",
              marginRight: "2rem",
              padding: "unset",
              marginBottom: "1rem",
              paddingBottom: "15px",
            }}
          >
            <>
              {Number(permissionLevel) === 1 && (
                <SectionTitle>
                  📁 Backups com Sucesso de Arquivos (últimos 10 - todos os
                  usuários)
                </SectionTitle>
              )}
              {Number(permissionLevel) !== 1 && (
                <SectionTitle>
                  📁 Backups com Sucesso de Arquivos (últimos 10)
                </SectionTitle>
              )}
              <FiltroContainer>
                <FiltroBotao
                  ativo={filterArq === "day" && !dateArq}
                  onClick={() => setFilterArq("day")}
                >
                  Hoje
                </FiltroBotao>
                <FiltroBotao
                  ativo={filterArq === "week" && !dateArq}
                  onClick={() => setFilterArq("week")}
                >
                  Semana
                </FiltroBotao>
                <FiltroBotao
                  ativo={filterArq === "all" && !dateArq}
                  onClick={() => setFilterArq("all")}
                >
                  Todos
                </FiltroBotao>

                <DataInput
                  type="date"
                  value={dateArq}
                  onChange={(e) => setDateArq(e.target.value)}
                />
                {dateArq && (
                  <LimparDataBotao onClick={() => setDateArq("")}>
                    ✖
                  </LimparDataBotao>
                )}
              </FiltroContainer>
              <BackupList>
                {backupsSucessoArquivos.map((b) => (
                  <BackupCard key={b.ID_BACKUP_STATUS}>
                    {permissionLevel === 1 && (
                      <p
                        style={{ marginTop: 0, fontSize: 14, color: "#8888c7" }}
                      >
                        Usuário: 👤 {b.USER_EMAIL}
                      </p>
                    )}
                    <p style={{ marginTop: 0 }}>
                      Status: {b.STATUS === "enviando" ? "🟡" : "✅"} {b.STATUS}
                    </p>
                    {b.STATUS === "enviando" && (
                      <ProgressBar progress={b.PROGRESS} />
                    )}
                    <p style={{ marginTop: 0 }}>
                      <strong style={{ fontSize: "small" }}>
                        {b.FILE_NAME}
                      </strong>
                    </p>
                    <p>{b.DETAILS}</p>
                    <small>{new Date(b.CREATED_AT).toLocaleString()}</small>
                  </BackupCard>
                ))}
              </BackupList>
              {backupsSucessoArquivos.length === 0 && (
                <EmptyMessage>
                  Nenhum backup de arquivos com sucesso.
                </EmptyMessage>
              )}
            </>
          </Card>
        )}
      </Main>
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div`
  min-height: 100dvh;
  background: #0f0f0f;
  color: #fff;
  padding-top: 60px; /* altura do header */
  padding-left: 240px; /* espaço da sidebar no desktop */
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 760px) {
    padding-left: 0; /* sem espaço fixo no mobile */
  }
`;

const TableViewport = styled.div`
  width: 100%;
  overflow-x: visible;

  @media (max-width: 1380px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  border-radius: 8px;
`;

const ChartWrapper = styled.div`
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  overflow: hidden;

  .apexcharts-canvas,
  .apexcharts-svg {
    max-width: 100% !important;
    background: transparent !important;
  }

  .apexcharts-tooltip-text-y-value,
  .apexcharts-tooltip-text-z-value,
  .apexcharts-tooltip-text-goals-value {
    margin-left: 0 !important;
  }
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  /* CRUCIAL em layouts flex: permite encolher e não forçar largura */
  min-width: 0;
`;

const EmptyMessage = styled.p`
  text-align: center;
  color: #888;
  margin: 1rem 2rem 2rem;
  font-style: italic;
`;

const Content = styled.div`
  padding: 2rem;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

const Card = styled.div`
  background: #1a1a1a;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`;

const CardTitle = styled.p`
  font-size: 0.9rem;
  color: #aaa;
`;

const CardValue = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 0.5rem;
`;

const SectionTitle = styled.h2`
  margin: 1rem 2rem 0.5rem;
  font-size: 1.2rem;
  color: #ddd;
`;

const BackupList = styled.div`
  padding: 0 2rem;
  display: grid;
  gap: 1rem;

  /* 4 colunas no desktop */
  grid-template-columns: repeat(4, minmax(0, 1fr));

  /* quebra suave conforme a largura */
  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const BackupCard = styled.div`
  background: #1f1f1f;
  border-left: 5px solid
    ${({ status }) =>
      status === "erro"
        ? "#e74c3c"
        : status === "enviando"
          ? "#f1c40f"
          : status === "preparando"
            ? "#9b59b6"
            : "#2ecc71"};
  padding: 1rem;
  border-radius: 8px;
`;

const ProgressBar = ({ progress }) => (
  <div
    style={{
      background: "#333",
      borderRadius: "4px",
      marginTop: "0.5rem",
      height: "8px",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        width: `${progress}%`,
        height: "100%",
        background: "#3498db",
        transition: "width 0.5s",
      }}
    />
  </div>
);

const FiltroContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 2rem;

  @media (max-width: 760px) {
    display: grid;
  }
`;

const FiltroBotao = styled.button`
  padding: 0.5rem 1rem;
  background: ${({ ativo }) => (ativo ? "#3498db" : "#1a1a1a")};
  color: ${({ ativo }) => (ativo ? "white" : "#ccc")};
  border: 1px solid #333;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #2980b9;
    color: white;
  }
`;

const DataInput = styled.input`
  background: #1a1a1a;
  color: #ccc;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 0.5rem;

  // Estilo do ícone do calendário no Chrome
  &::-webkit-calendar-picker-indicator {
    filter: invert(1); /* Inverte a cor (preto → branco) */
    cursor: pointer;
  }
`;

const LimparDataBotao = styled.button`
  background: transparent;
  color: #ccc;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0 0.5rem;
  line-height: 1;

  &:hover {
    color: #f44336;
  }
`;
